import { useAddToCart, useCart, useRemoveCartItem } from 'src/services/api/queries/queries'
import { Product } from 'src/types/types'

interface ProductActions {
  addToCart: (onSuccess?: () => void, onError?: () => void) => void
  removeFromCart: (onSuccess?: () => void, onError?: () => void) => void
  isLoading: boolean
  isAddedToCart: boolean
}

export const useProductActions = (product: Product): ProductActions => {
  const addToCartMutation = useAddToCart()
  const removeFromCartMutation = useRemoveCartItem()
  const { data: cartData } = useCart()

  const cartKey = cartData?.items.find((item) => item.id === product?.id)?.key

  const handleAddToCart = (onSuccess?: () => void, onError?: () => void) => {
    if (product?.id) {
      addToCartMutation.mutate(
        { productId: product.id, quantity: 1 },
        {
          onSuccess: () => {
            onSuccess?.()
          },
          onError: () => {
            onError?.()
          },
        }
      )
    }
  }

  const handleRemoveFromCart = (onSuccess?: () => void, onError?: () => void) => {
    if (cartKey) {
      removeFromCartMutation.mutate(cartKey, {
        onSuccess: () => {
          onSuccess?.()
        },
        onError: () => {
          onError?.()
        },
      })
    }
  }

  return {
    addToCart: handleAddToCart,
    removeFromCart: handleRemoveFromCart,
    isLoading: addToCartMutation.isLoading || removeFromCartMutation.isLoading,
    isAddedToCart: !!cartKey,
  }
}
